import { render } from "./CRMAgentTemplateMessagesComponent.vue?vue&type=template&id=0c50014b"
import script from "./CRMAgentTemplateMessagesComponent.vue?vue&type=script&lang=js"
export * from "./CRMAgentTemplateMessagesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__